import docxIcon from "../../../../../../../../assets/images/doc-docx.svg";
import pptIcon from "../../../../../../../../assets/images/doc-ppt.svg";
import textIcon from "../../../../../../../../assets/images/doc-text.svg";

const fileIcons = {
    "application/msword": docxIcon,
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": docxIcon,
    "application/vnd.ms-powerpoint": pptIcon,
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": pptIcon,
    "text/plain": textIcon,
};

const Icon = ({type}) => {
    const icon = fileIcons[type] || textIcon;
    return (
        <div className="main-content__documents-file-icon">
            <img src={icon} alt="" />
        </div>
    );
};

export default Icon;
